import React, { useState, useEffect } from "react";
import { Doughnut, Bar } from "react-chartjs-2";
import { Chart as ChartJS, registerables } from "chart.js";
import axios from ".././axios-interceptor";
import { base_url, } from "../utilities";
import { Link, useNavigate } from "react-router-dom";
import "react-toastify/dist/ReactToastify.css";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import InvestorSideNavBar from "./SideNavBarInvestor";
import InvestorNavBarMain from "./InvestorNavBar";
import InvestorKycDocumentsModal from "./InvestorKYCDocumentsModel";
import { toast } from "react-toastify";
import Cookies from 'js-cookie';

window.Buffer = window.Buffer || require("buffer").Buffer;



const InvestorDashboard = (props) => {
  const navigate = useNavigate(); 
useEffect(()=>{
  if (Cookies.get("User_Accesstoken_Investor") == null) {
    navigate('/');
  }
},[])
  ChartJS.register(...registerables);
  const [investordataUser, setInvestordataUser] = useState([]);
  const [showuploadKYC, setModalShowUploadKYC] = React.useState(false);
  const [chartData, setChartData] = useState();
  const [chartDatatwo, setChartDatatwo] = useState();
  const [chartData3, setChartData3] = useState();




  const [invDashboardData, setInvDashboardData] = useState([])
  const [loading, setLoading] = useState(true);
  const [chart_loaded, setChartLoaded] = React.useState(false);
  function disableBackButton() {
    window.history.pushState(null, null, window.location.pathname);
    window.addEventListener('popstate', function (event) {
      window.history.pushState(null, null, window.location.pathname);
    });
  }

  const returns_lowerLimit = 0;
  const returns_upperLimit = 100;
  const returns_increment = 20;

  const returns_numbers = [];

  for (let i = returns_lowerLimit; i <= returns_upperLimit; i += returns_increment) {
    returns_numbers.push(i);
  }
  useEffect(() => {
    disableBackButton()
    axios
      .post(base_url + "investor-master/get_investor_master_user", {
        user_id: Cookies.get("investor_user_id"),
      })
      .then((res) => {
        setInvestordataUser(res.data.data);
        Cookies.set("investor_id", res?.data?.data?.investor_id, { expires: 7 })
        axios
          .post(base_url + "investor-master/get_investor_dashboard", {
            investor_id: res.data?.data?.investor_id,
          })
          .then((res) => {
            // setInvDashboardData(res.data.data)

            let myDynamicArray = []
            let myDynamicArraytwo = []
            let return_loanAmt_x_axis = []
            let returns_y_axis = []
            let backgroundColor = ["#0A369D", "#4472CA", "#5E7CE2", '#92B4F4', '#F4CD2A', '#A6A6A6', '#12245A']
            let backgroundColortwo = ["#12245A", "#4472CA", "#5E7CE2", '#92B4F4', '#F4CD2A', '#A6A6A6', '#12245A']
            if (res.data.data)
              res.data.data.type_of_facility?.map((i, index) => {
                backgroundColor.map((color, id) => {
                  if (index == id) {
                    i.color_idx = color;
                  }
                });
              })
            res.data.data.industry?.map((i, index) => {
              backgroundColortwo.map((color, id) => {
                if (index == id) {
                  i.color_idx = color;
                }
              });
            })
            setInvDashboardData(res.data.data);
            res.data.data.type_of_facility?.map((i) => {
              if (i.facility_type_percentage !== '' || i.facility_type_percentage !== undefined) {
                myDynamicArray.push(Number(i.facility_type_percentage))
              }
            });
            res.data.data.industry?.map((i) => {
              if (i.industry_type_percentage !== '' || i.industry_type_percentage !== undefined) {
                myDynamicArraytwo.push(Number(i.industry_type_percentage))
              }
            })

            let returnsBarGraph = [];
            returnsBarGraph = res.data.data.returns == undefined ? [] : res.data.data.returns;
            for (let i = 0; i < 6; i++) {
              if (returnsBarGraph[i] === undefined) {
                let objecti = [{ final_loan_amount: 0, return: 0 }]
                returnsBarGraph.push(objecti)

              }
            }
            returnsBarGraph.map((i) => {
              if (i.final_loan_amount !== '' || i.final_loan_amount !== undefined) {
                return_loanAmt_x_axis.push(isNaN(i.final_loan_amount) ? "" : ("$" + Number(i.final_loan_amount)))
                returns_y_axis.push(Number(i.return))
              }
            })

            setChartData({
              datasets: [
                {
                  data: myDynamicArray,
                  backgroundColor: backgroundColor,
                  hoverOffset: 10,
                },
              ],
            })
            setChartDatatwo({
              datasets: [
                {
                  data: myDynamicArraytwo,
                  backgroundColor: backgroundColortwo,
                  hoverOffset: 10,
                },
              ],
            })


            setChartData3({
              labels: return_loanAmt_x_axis,
              datasets: [
                {
                  label: "Return",
                  data: returns_y_axis,
                  backgroundColor: ["#BAA38B"],
                  hoverbackgroundColor: [
                    "rgba(78,169,172,0.2)",
                    "rgba(40,119,150,0.2)",
                    "rgba(212,167,74,0.2)",
                    "rgba(63,149,208,0.2)",
                  ],
                  borderRadius: Number.MAX_VALUE,
                  hoverOffset: 10,
                  borderSkipped: false,
                  barThickness: 20,
                  color: ["#FFFFFF"],

                },
              ],
            })
 

            setLoading(false)
            setChartLoaded(true);



          })
          .catch((err) => {
            console.log(err);
          });
      })
      .catch((err) => {
        if (err.response.statusText == "Unauthorized") {
          toast.error("Your session has expired. Please login again", {
            toastId: 7,
          });
          Cookies.remove("User_Accesstoken_Investor");
          Cookies.remove("User_Refreshtoken_Investor");
          navigate("/");
        }
      });


  }, []);



  const lowerLimit = 1;
  const upperLimit = 1000;
  const increment = 200;

  const numbers = [];

  for (let i = lowerLimit; i <= upperLimit; i += increment) {
    numbers.push(i);
  }

  const currencyFormattedNumbers = numbers.map((number) => `$${number}K`);
  const [tooltipText, setTooltipText] = useState("");

  const handleTooltip = () => {
    setTooltipText(`Total investment: $${Number(invDashboardData.total_investment).toLocaleString()}`);
  };
  const handleTooltipTotalRepaid = () => {
    setTooltipText(`Total Repaid: $${Number(invDashboardData.total_repaid).toLocaleString()}`);
  };
  const handleTooltipNetEarnings = () => {
    setTooltipText(`Net Earnings: $${Number(invDashboardData.profit_gain).toLocaleString()}`);
  };

  const hideTooltip = () => {
    setTooltipText("");
  };

  let returns = [];
  for (let i = 5; i <= 40; i += 5) {
    returns.push(i);
  }
  const convertToPlain = (html) => {
    var tempDivElement = document.createElement("div");
    tempDivElement.innerHTML = html;
    return tempDivElement.textContent || tempDivElement.innerText || "";
  }
  if (
    Cookies.get("investor_user_id") != null ||
    Cookies.get("investor_user_id") != undefined
  ) {
    return (
      <div style={{ display: "flex", height: "100vh" }}>
        <InvestorSideNavBar />

        <main style={{ width: "100%" }}>
          <InvestorNavBarMain
            investorname={
              investordataUser?.investor_name === undefined
                ? ""
                : investordataUser?.investor_name || <Skeleton count={1} />
            }
          />
          {loading ? (
            <div>
              <div>
                <Skeleton
                  width={1040}
                  height={150}
                  count={1}
                  className="skeleton_mrgn"
                />
              </div>
              <div className="d-flex gap-5 ">
                <div>
                  <Skeleton
                    width={300}
                    height={150}
                    count={2}
                    className="skeleton_mrgn"
                  />
                </div>
                <div>
                  <Skeleton
                    width={300}
                    height={150}
                    count={2}
                    className="skeleton_mrgn"
                  />
                </div>
                <div>
                  <Skeleton
                    width={300}
                    height={150}
                    count={2}
                    className="skeleton_mrgn"
                  />
                </div>
              </div>
            </div>
          ) : (
            <div className={`content_main_body db_body`}>
              <div className="row d-flex justify-content-between mb-4 db_media_scrn">
                <div className="col d-flex justify-content-between justify-content-lg-start align-items-center  ">
                  <div className="mb-0 me-lg-4 me-0 dashboard_isues"> Dashboard </div>
                </div>
                <div className="col d-flex justify-content-between justify-content-lg-start align-items-center  ">
                  <img src="./images/Document_inv.svg" alt="true" />
                  <h4
                    onClick={() => setModalShowUploadKYC(true)}
                    className="mb-0 text_bolder_investor pe-sm-2 pe-0 ps-2"
                  >
                    Click Here to Upload KYC Documents
                  </h4>
                </div>
                <InvestorKycDocumentsModal
                  show={showuploadKYC}
                  onHide={() => setModalShowUploadKYC(false)}
                />
                <div className="col d-flex justify-content-lg-end justify-content-between mt-2 mt-lg-0">
                  <button className="btn blue_btn">
                    <Link to='/investmentopportunities'>Investment Opportunities</Link>
                  </button>
                </div>
              </div>

              <div className="">
                <div className="d-flex  justify-content-lg-start mb-3 justify-content-between ">
                  <div className="d-flex gap-2 me-5">
                    <div>
                      <img src="./images/icons/bars_icon.svg" alt="true" />
                    </div>
                    <div>
                      <b style={{ color: "#7C8495" }}>Total Invested</b>
                      <br />
                      <strong
                        style={{
                          color: "#3D79F3",
                          fontSize: "21px",
                          fontWeight: "500",
                        }}
                      >
                        $ {isNaN(invDashboardData.total_investment) ? 0 : Number(invDashboardData.total_investment).toLocaleString()}
                      </strong>
                    </div>
                  </div>

                  <div className="d-flex gap-2 mr-lg-5 mr-0 sesame_profit_icon">
                    <div>
                      <img src="./images/icons/currency_icon.svg" alt="true" />
                    </div>
                    <div>
                      <b style={{ color: "#7C8495" }}>Total Repaid</b>
                      <br />
                      <b
                        style={{
                          color: "#BAA38B",
                          fontSize: "21px",
                          fontWeight: "500",
                        }}
                      >
                        $ {isNaN(invDashboardData.total_repaid) ? 0 : Number(invDashboardData.total_repaid).toLocaleString()}
                      </b>
                    </div>
                  </div>
                  <div className="d-flex gap-2 mr-lg-5 mr-0 sesame_profit_icon">
                    <div>
                      <img src="./images/icons/profitgain.svg" alt="true" />
                    </div>
                    <div>
                      <b style={{ color: "#7C8495" }}>Profit Gain</b>
                      <br />
                      <b
                        style={{
                          color: "#3D79F3",
                          fontSize: "21px",
                          fontWeight: "500",
                        }}
                      >
                        $ {isNaN(invDashboardData.profit_gain) ? 0 : Number(invDashboardData.profit_gain).toLocaleString()}
                      </b>
                    </div>
                  </div>

                  <div className="d-flex gap-2 mr-lg-5 mr-0 sesame_profit_icon">
                    <div>
                      <img src="./images/icons/Amount_icon.svg" alt="true" />
                    </div>
                    <div>
                      <b style={{ color: "#7C8495" }}>Amount Available</b>
                      <br />
                      <b
                        style={{
                          color: "#3D79F3",
                          fontSize: "21px",
                          fontWeight: "500",
                        }}
                      >
                        {isNaN(invDashboardData.amount_transferred) || isNaN(invDashboardData.total_investment)
                    ? "$ 0"
                    : `${(
                        Number(invDashboardData.amount_transferred) - 
                        Number(invDashboardData.total_investment)
                      ).toLocaleString('en-US',{
                        style:'currency',
                        currency:'USD'
                      })}`
                  }
                      </b>
                    </div>
                  </div>
                </div>

                <div className=" mb-lg-4 row ">
                  <div className=" col card shadow-ben  me-lg-4 mb-3 p-4 inv_db_Card_Size1">
                    <h4 className="Inv_db_card_tilte">My Investments</h4>
                    <div className="row">
                      <div className="  my-xxl-4 my-lg-2 d-flex ">
                        <div className="col  ">
                          <p>Total Investment</p>
                        </div>
                        <div className="px-lg-2 col-lg-10 ben_progress_bar_main_inv">
                          <span
                            className="progress"
                            role="progressbar"
                            aria-label="Basic example"
                            aria-valuenow="25"
                            aria-valuemin="0"
                            aria-valuemax="100"
                            onMouseEnter={handleTooltip}
                            onMouseLeave={hideTooltip}
                          >
                            <div
                              className="progress-bar  ben_progress_bar_blue"
                              style={{
                                width: `${(invDashboardData.total_investment / 1000000) * 100}%`,
                                borderRadius: "10px"
                              }}
                              data-toggle="tooltip"
                              data-placement="top"
                              title={tooltipText}
                            ></div>
                          </span>
                        </div>
                      </div>
                      <div className="  my-xxl-4 my-lg-3 d-flex">
                        <div className="col  ">
                          <p>Total Repaid</p>
                        </div>
                        <div className="px-lg-2 col-lg-10 ben_progress_bar_main_inv">
                          <span
                            className="progress "
                            role="progressbar"
                            aria-label="Basic example"
                            aria-valuenow="25"
                            aria-valuemin="0"
                            aria-valuemax="100"
                            onMouseEnter={handleTooltipTotalRepaid}
                            onMouseLeave={hideTooltip}
                          >
                            <div
                              className="progress-bar ben_progress_bar"
                              style={{ width: `${(invDashboardData.total_repaid / 1000000) * 100}%`, borderRadius: "10px" }}
                              title={tooltipText}
                            ></div>
                          </span>
                        </div>
                      </div>

                      <div className="  my-xxl-4 my-lg-3 d-flex">
                        <div className="col  ">
                          <p>Net Earnings</p>
                        </div>
                        <div className="px-lg-2 col-lg-10 ben_progress_bar_main_inv">
                          <span
                            className="progress "
                            role="progressbar"
                            aria-label="Basic example"
                            aria-valuenow="25"
                            aria-valuemin="0"
                            aria-valuemax="100"
                            onMouseEnter={handleTooltipNetEarnings}
                            onMouseLeave={hideTooltip}
                          >
                            <div
                              className="progress-bar ben_progress_bar_gray"
                              style={{ width: `${(invDashboardData.profit_gain / 1000000) * 100}%`, borderRadius: "10px" }}
                              title={tooltipText}
                            ></div>
                          </span>
                        </div>
                      </div>
                      <div className="d-flex inv_db_curency_styl">
<div className="col-lg-3"></div>

                        <div className="col-lg-10">
                          <div className="d-flex inv_db_currency">
                            {currencyFormattedNumbers.map((amt, index) => {
                              return <ol className="ps-lg-2 p-0" key={index}>{amt == "$1000K" ? "$1M" : amt}</ol>;
                            })}
                          </div>
                          <div className="my_inv_right_arrow ps-1 ps-xxl-3">
                            <span className="inv_db_tinv">
                              <img
                                className="me-2"
                                src="./images/Arrow.svg"
                                alt=""
                              />
                              Investment
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col  p-4 card  shadow-ben  mb-3 inv_db_Card_Size">
                    <h4 className="Inv_db_card_tilte">Returns</h4>
                    <div className="bar_chart_inv_db d-flex">

                      <div className="">
                        <span className="">

                          <div><img style={{ width: '13px', marginTop: '-20px' }} className="" src="./images/arrowRight.svg" alt="" /></div>

                        </span>
                      </div>
                      <Bar data={chartData3}
                        options={{
                          scales: {
                            x: {
                              grid: {
                                display: false,
                              },
                            },
                            y: {
                              grid: {
                                display: false,
                              },
                              title: {
                                display: true,

                                font: {
                                  size: 11,
                                },
                                color: 'white',
                              },
                              ticks: {
                                font: {
                                  color: "#FFFFFF"
                                }
                              }
                            },
                          },
                          responsive: true,
                          plugins: {
                            datalabels: {
                              display: true,
                              color: "white",
                              font: {
                                size: 11,
                              },
                            },
                            legend: {

                              position: "bottom",
                              color: "#FFFFFF",
                              align: "start",
                              display: false,
                              textDirection: "underline",
                            },
                          },

                        }}
                      />
                    </div>
                    <div className=" ms-lg-5">
                      <span className="inv_db_tinv">
                        <img className="me-2" src="./images/Arrow.svg" alt="" />
                        Investment
                      </span>
                    </div>
                  </div>
                </div>

                <div className="row">
                  <div className="col card shadow-ben me-lg-4 mb-3 p-3 secondrowcard_height card_title_txt">
                    <article>Industry </article>
                    <div className=" ">
                      <div className="d-flex justify-content-between">
                        <div className="col-lg-5 doughnut_div"
                          style={{ height: "168px", width: "168x" }}
                        >

                          <Doughnut
                            data={chartDatatwo}
                            options={{
                              plugins: {
                                tooltip: false,
                                datalabels: {
                                  formatter: function (context) {
                                    return context + "%";
                                  },
                                  display: true,
                                  color: "white",
                                  font: {
                                    size: 11,
                                  },
                                },

                              },
                            }}
                          /> 
                        </div>
                        <div className="col  d-flex flex-column typ_of_feclty_labels  ms-2 me-1">
                          {invDashboardData.industry?.length>0 ? invDashboardData.industry?.map((i, index) => {
                            return (<span className="d-flex  row mt-" key={index}>
                              <div
                                className="percent_first col-md-3 pt-md-2 pt-0"
                                style={{ color: i.color_idx }}
                              >
                                {i.industry_type_percentage}%
                              </div>
                              <div className="inv_db_txt col pt-2 mt-1">
                                {" "}
                                {i.industry_type}
                              </div>
                            </span>)


                          }): <div className="text-left fw-bold  ">No Data</div>}
                        </div>
                      </div>
                    </div>
                  </div>

                  <div className="col card shadow-ben  me-l mb-3 p-3 secondrowcard_height  card_title_txt ">
                    <article>Type of Facility </article>
                    <div className=" ">
                      <div className="d-flex justify-content-between">
                        <div className="col-lg-5 doughnut_div"
                          style={{ height: "168px", width: "168x" }}
                        >
                          <Doughnut
                            data={chartData}
                            options={{
                              plugins: {
                                tooltip: false,
                                datalabels: {
                                  formatter: function (context) {
                                    return context + "%";
                                  },
                                  display: true,
                                  color: "white",
                                  font: {
                                    size: 11,
                                  },
                                },

                              },
                            }}
                          />
                        </div>
                        <div className="col d-flex flex-column typ_of_feclty_labels ms-2 me-1">
                          {invDashboardData.type_of_facility?.length>0 ? invDashboardData.type_of_facility?.map((i, index) => {
                            return (<span className="d-flex  row mt-" key={index}>
                              <div
                                className="percent_first col-md-3 pt-md-2 pt-0"
                                style={{ color: i.color_idx }}
                              >
                                {i.facility_type_percentage}%
                              </div>
                              <div className="inv_db_txt col pt-2 mt-1">
                                {" "}
                                {i.facility_type}
                              </div>
                            </span>)


                          }) : <div className="text-left fw-bold ">No Data</div>}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              
              </div>
            </div>)}
        </main>





      </div>
    );
  }
};
export default InvestorDashboard;
